import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div
        className='container center center-column comp-container'
      >
        <div className='title'>Error 404!</div>
        <div className='subtitle'>Page not found</div>
      </div>
    );
  }
}

export default NotFound;
